var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-section',{attrs:{"title":"Indicatori di qualità (IQ) e rispetto dei livelli di servizio","icon":"it-inbox","titleSize":"sm"}},[_c('monitoring-qualitative-indicator-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }